import { getDriverCanBuyOnline, getDriverCoverageOptions, getDriverDiscounts, getDriverEaseOfUse, getDriverFinancialStrengthRating, getDriverNAICComplaints, getDriverPoliciesOffered } from '@nerdwallet/marketplace/drivers/insurance';
import { getSubProductType } from '@nerdwallet/marketplace/selectors/common';
import { INSURANCE_SUB_PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
export default (function (_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  var subProductType = getSubProductType(marketplaceEntity);
  var drivers = [];

  switch (subProductType) {
    case INSURANCE_SUB_PRODUCT_TYPES.HOME:
    case INSURANCE_SUB_PRODUCT_TYPES.HOMEOWNERS_PROPERTY:
      drivers = [getDriverNAICComplaints(marketplaceEntity), getDriverCoverageOptions(marketplaceEntity), getDriverDiscounts(marketplaceEntity)];
      break;

    case INSURANCE_SUB_PRODUCT_TYPES.LIFE:
    case INSURANCE_SUB_PRODUCT_TYPES.LIFE_SUB:
      drivers = [getDriverFinancialStrengthRating(marketplaceEntity), getDriverNAICComplaints(marketplaceEntity), getDriverPoliciesOffered(marketplaceEntity), getDriverCanBuyOnline(marketplaceEntity)];
      break;

    case INSURANCE_SUB_PRODUCT_TYPES.AUTO:
    case INSURANCE_SUB_PRODUCT_TYPES.CAR:
    default:
      drivers = [getDriverNAICComplaints(marketplaceEntity), getDriverEaseOfUse(marketplaceEntity), getDriverDiscounts(marketplaceEntity)];
      break;
  }

  return {
    drivers: drivers
  };
});